import {
  AmountOffOrder,
  AmountOffProducts,
  BuyXGetY,
  DiscountState,
  FreeShipping,
  PageType,
  TabType,
} from "@/types/coupon/discount";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetStoreSpecificState } from "@/store/actions/storeActions";

const initialState: DiscountState = {
  currentTab: "code",
  amountOffProducts: {
    couponId: undefined,
    title: "",
    discount_code: "",
    discount_type: "percentage",
    discount_value_fixed: "0",
    discount_value_percentage: "0",
    discount_value_max: "0",
    minimum_purchase_type: "nothing",
    minimum_purchase_value_amount: "0",
    minimum_purchase_value_quantity: "0",
    start_date: undefined,
    end_date: undefined,
    applicable_products_type: "specific",
    applicable_products: [],
    applicable_collections: [],
  },
  amountOffOrder: {
    couponId: undefined,
    title: "",
    discount_code: "",
    discount_type: "percentage",
    discount_value_fixed: "0",
    discount_value_percentage: "0",
    discount_value_max: "0",
    minimum_purchase_type: "nothing",
    minimum_purchase_value_amount: "0",
    minimum_purchase_value_quantity: "0",
    start_date: undefined,
    end_date: undefined,
  },
  buyXGetY: {
    couponId: undefined,
    title: "",
    discount_code: "",
    discount_type: "percentage",
    discount_value_fixed: "0",
    discount_value_percentage: "0",
    discount_value_max: "0",
    applicable_products_type: "specific",
    applicable_x_products: [],
    applicable_x_collections: [],
    applicable_y_products: [],
    applicable_y_collections: [],
    minimum_purchase_type: "nothing",
    minimum_purchase_value_amount: "0",
    minimum_purchase_value_quantity: "0",
    get_y_quantity: 0,
    start_date: undefined,
    end_date: undefined,
  },
  freeShipping: {
    couponId: undefined,
    title: "",
    discount_code: "",
    discount_type: "percentage",
    discount_value_fixed: "0",
    discount_value_percentage: "0",
    discount_value_max: "0",
    minimum_purchase_type: "nothing",
    minimum_purchase_value_amount: "0",
    minimum_purchase_value_quantity: "0",
    start_date: undefined,
    end_date: undefined,
  },
};

export const discountSlice = createSlice({
  name: "discount",
  initialState,
  reducers: {
    clearDiscount(state, action: PayloadAction<{ page: PageType }>) {
      switch (action.payload.page) {
        case "amountOffProducts":
          state.amountOffProducts = initialState.amountOffProducts;
          break;
        case "amountOffOrder":
          state.amountOffOrder = initialState.amountOffOrder;
          break;
        case "buyXGetY":
          state.buyXGetY = initialState.buyXGetY;
          break;
        case "freeShipping":
          state.freeShipping = initialState.freeShipping;
          break;
        default:
          break;
      }
    },
    setCurrentTab(state, action: PayloadAction<TabType>) {
      state.currentTab = action.payload;
    },
    updateAmountOffProducts(
      state,
      action: PayloadAction<Partial<AmountOffProducts>>,
    ) {
      state.amountOffProducts = {
        ...state.amountOffProducts,
        ...action.payload,
        couponId:
          action.payload.couponId !== undefined
            ? action.payload.couponId
            : state.amountOffProducts.couponId,
      };
    },
    resetAmountOffProducts(state) {
      state.amountOffProducts = initialState.amountOffProducts;
    },
    updateBuyXGetY(state, action: PayloadAction<Partial<BuyXGetY>>) {
      state.buyXGetY = {
        ...state.buyXGetY,
        ...action.payload,
        couponId:
          action.payload.couponId !== undefined
            ? action.payload.couponId
            : state.buyXGetY.couponId,
      };
    },
    resetBuyXGetY(state) {
      state.buyXGetY = initialState.buyXGetY;
    },
    updateAmountOffOrder(
      state,
      action: PayloadAction<Partial<AmountOffOrder>>,
    ) {
      state.amountOffOrder = {
        ...state.amountOffOrder,
        ...action.payload,
        couponId:
          action.payload.couponId !== undefined
            ? action.payload.couponId
            : state.amountOffOrder.couponId,
      };
    },
    resetAmountOffOrder(state) {
      state.amountOffOrder = initialState.amountOffOrder;
    },
    updateFreeShipping(state, action: PayloadAction<Partial<FreeShipping>>) {
      state.freeShipping = {
        ...state.freeShipping,
        ...action.payload,
        couponId:
          action.payload.couponId !== undefined
            ? action.payload.couponId
            : state.freeShipping.couponId,
      };
    },
    resetFreeShipping(state) {
      state.freeShipping = initialState.freeShipping;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreSpecificState, () => initialState);
  },
});

export const {
  clearDiscount,
  setCurrentTab,
  updateAmountOffProducts,
  updateBuyXGetY,
  updateAmountOffOrder,
  updateFreeShipping,
  resetAmountOffProducts,
  resetBuyXGetY,
  resetAmountOffOrder,
  resetFreeShipping,
} = discountSlice.actions;

export default discountSlice.reducer;
